/**
 * A furniture drag emits `furniture_moved` only when the piece's
 * center actually changed. Pointer-down / pointer-up on the same
 * spot, and drags that snap back to the origin, stay quiet.
 */
export function furnitureMovedName(
  origin: { x: number; y: number } | null,
  item: { name: string; x: number; y: number } | null
): string | null {
  if (!origin || !item) return null;
  if (item.x === origin.x && item.y === origin.y) return null;
  return item.name;
}
